var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            _vm._b({}, "v-col", _vm.column.id, false),
            [
              !_vm.id
                ? _c("v-text-field", {
                    attrs: {
                      label: "ID",
                      value: _vm.id,
                      disabled: "",
                      "error-messages": _vm.errors.id
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-col",
            _vm._b({}, "v-col", _vm.column.stockCategory, false),
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Stock Category",
                  items: _vm.stockCategories,
                  "item-value": "id",
                  "item-text": "name",
                  "error-messages": _vm.errors.stockCategoryId
                },
                model: {
                  value: _vm.stockCategoryId,
                  callback: function($$v) {
                    _vm.stockCategoryId = $$v
                  },
                  expression: "stockCategoryId"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            _vm._b({}, "v-col", _vm.column.description, false),
            [
              _c("v-text-field", {
                attrs: {
                  label: "Description",
                  "error-messages": _vm.errors.description
                },
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            _vm._b({}, "v-col", _vm.column.order, false),
            [
              _c("v-text-field", {
                attrs: {
                  label: "Order",
                  type: "number",
                  "error-messages": _vm.errors.order
                },
                model: {
                  value: _vm.order,
                  callback: function($$v) {
                    _vm.order = $$v
                  },
                  expression: "order"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }